var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnhanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1667 58.75V56.6667H33.6833L34.6354 52.5H44.1667V50.4167H20.2083C18.4854 50.4167 17.0833 49.0146 17.0833 47.2917V46.25H44.1667V44.1667H17.0833V24.375C17.0833 22.6521 18.4854 21.25 20.2083 21.25H59.7917C61.5146 21.25 62.9167 22.6521 62.9167 24.375V35.8334H65V24.375C65 21.5021 62.6625 19.1667 59.7917 19.1667H20.2083C17.3375 19.1667 15 21.5021 15 24.375V47.2917C15 50.1646 17.3375 52.5 20.2083 52.5H32.4979L31.0687 58.75H44.1667ZM62.9167 44.1667V43.125C62.9167 39.1042 59.6458 35.8334 55.625 35.8334C51.6042 35.8334 48.3333 39.1042 48.3333 43.125V44.1667H46.25V62.9167H65V44.1667H62.9167ZM50.4167 43.125C50.4167 40.2521 52.7542 37.9167 55.625 37.9167C58.4958 37.9167 60.8333 40.2521 60.8333 43.125V44.1667H50.4167V43.125ZM48.3333 46.25V60.8334H62.9167V46.25H48.3333ZM56.6667 56.6667V50.4167H54.5833V56.6667H56.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceIcon);
export default __webpack_public_path__ + "static/media/enhance_icon.030f36fce1b9db1862884f786b625c2f.svg";
export { ForwardRef as ReactComponent };